import ticketDetails from '../localization-messages/ticketDetails/nb-NO.json';
import ticketCancelForm from '../localization-messages/ticketCancelForm/nb-NO.json';
import ticketListing from '../localization-messages/ticketListing/nb-NO.json';
import ticketForm from '../localization-messages/ticketForm/nb-NO.json';
import headerFooter from '../localization-messages/headerFooter/nb-NO.json';
import reconfirmUserDetailsModal from '../localization-messages/reconfirmUserDetailsModal/nb-NO.json';
import termsModal from '../localization-messages/termsModal/nb-NO.json';

export const nbNOTranslations = {
  ticketDetails,
  ticketCancelForm,
  ticketListing,
  ticketForm,
  headerFooter,
  reconfirmUserDetailsModal,
  termsModal,
};
